export default "__VITE_ASSET__BSfPyzCj__"